import { render, staticRenderFns } from "./Q8.vue?vue&type=template&id=576f14f2&"
import script from "./Q8.vue?vue&type=script&lang=js&"
export * from "./Q8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports